import React, {useEffect, useState} from 'react';
import PojectChartLowSingle from './PojectChartLowSingle';
import api from '../../../../api/axios';
import Cookies from 'js-cookie';

// Anzahl der anzuzeigenden Projekte
const showenAmount = 10;

const ProjectChartLow = () => {
    const [projects, setProjects] = useState([]);

    useEffect(() => {
        const fetchProjectData = async () => {
            try {
                // Access Token aus Cookies abrufen
                const accessToken = Cookies.get('accessToken');

                // Anfrage mit Authorization-Header durchführen
                const response = await api.get('/api/v1/project/stats/revenue/low', {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                // Beschränken der angezeigten Projekte auf die festgelegte Anzahl
                const fetchedProjects = response.data.projects.slice(0, showenAmount);
                setProjects(fetchedProjects);
            } catch (error) {
                console.error('Fehler beim Abrufen der Projektdaten:', error);
            }
        };

        fetchProjectData();
    }, []);

    return (
        <div className='flex flex-col justify-between w-full mt-2 overflow-visible'>
            {projects.map((project, index) => (
                <PojectChartLowSingle
                    key={project.number}
                    projectNumber={project.number} // Hinzugefügt: Projekt ID übergeben
                    subject={project.subject.length > 30 ? `${project.subject.substring(0, 30)}...` : project.subject}
                    revenue={project.revenue}
                    costs={project.costs}
                    yieldValue={project.yield}
                    siteManager={project.siteManager}
                    isLast={index === projects.length - 1}
                />
            ))}
        </div>
    );
};

export default ProjectChartLow;
